import { render, staticRenderFns } from "./SidebarNavTitle.vue?vue&type=template&id=5f92ee61"
import script from "./SidebarNavTitle.vue?vue&type=script&lang=js"
export * from "./SidebarNavTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports